<template>
  <div>
    <v-data-table :headers="headers" :items="productInterfaces" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Interfaces</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" persistent max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                small
              >
                Buat Interface
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">Buat Interface</v-card-title>
              <v-card-text>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.name" label="Nama Interface" required></v-text-field>
                </v-flex>  
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.no`]="{ item }">
        {{(productInterfaces.indexOf(item)+1) + '.'}}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="deleteItem(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
      <span class="text-center">No data available.</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import itemTemplate from '@/components/ItemTemplate.vue';
import { formatCurrency } from "@/libs/number";
export default {
  data: () => ({
    itemTemplate,
    dialog: false,
    expand: false,
    productInterfaces: [],
    defaultItem: {
      name: ""
    },
    editedItem: {
      name: ""
    },
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no"
      },
      {
        text: "Nama",
        align: "left",
        value: "name"
      },
      { text: "Actions", value: "action", sortable: false }
    ],
  }),

  computed: {
    ...mapGetters({
      dataProductInterface: "product_interfaces/getProductInterfaces",
    }),
    
    formTitle() {
      return this.editedIndex === -1 ? "Buat Item" : "Edit Item";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      createProductInterface: "product_interfaces/createProductInterface",
      updateProductInterface: "product_interfaces/updateProductInterface",
      deleteProductInterface: "product_interfaces/deleteProductInterface",
      getUserById: "user/getUserById",
    }),
    convertCurrency(total){
      return "Rp. "+formatCurrency(total);
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
      this.role = userLogin.roles[0].name
      this.permission = userLogin.permissions;
      this.productInterfaces = await this.dataProductInterface;
    }, 
    async save() {
       const payload = {
        ...this.editedItem
      }
      if(this.editedIndex > -1){
        try{
          const response = await this.updateProductInterface(payload);
          Object.assign(this.productInterfaces[this.editedIndex], response.data.attributes)
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success!',
            text: response.data.message
          });
        }catch(e){
          console.log(e)
        }
      }else{
        try{
          const response = await this.createProductInterface(payload); 
          this.productInterfaces.splice(0, 0, response.data.attributes);
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success',
            text: response.data.message
          })
        }catch(e){
          console.log(e)
        }
      }
      this.close();
    },
    editItem(item) {
      this.editedIndex = this.productInterfaces.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      const index = this.productInterfaces.indexOf(item);
      let result = confirm("Are you sure you want to delete?");
      if(result){  
        try {
          const response = await this.deleteProductInterface(item.id);
          this.productInterfaces.splice(index,1);
          this.$notify({
            group: 'custom-notification',
            type: 'success',
            title: 'Success',
            text: response.data.message
          });
        }catch(e) {
          console.log(e)
        }
      }
    }
  }
};
</script>
<style>
.vue-suggestion .vs__input {
    width: 100%;
    text-align: left;
    border-bottom: 1px solid black;
    max-height: 400px;
    overflow-y: auto;
    font-size: 16px;
    color: black;
    position: relative;
}
.vue-suggestion .vs__list {
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    border-bottom: 1px solid #023d7b;
    position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
    position: relative;
    z-index: 1;
    background-color: #fff;
    padding: 10px;
    border-left: 1px solid #023d7b;
    border-right: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
    border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
    background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
    position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
    cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
    background-color: #f3f6fa;
}
</style>